// Libraries
import { useEffect } from 'react'
import io from 'socket.io-client'
import * as Sentry from '@sentry/browser'

// Components
import utils from '../../utils/utils'
import API from '../../utils/api'

// Hooks
import useUserContext from '../../hooks/useUserContext'

export const useCasinoWs = ({ onWagerCreated, setShowMessageSaldo, setShowMessageError }) => {
  const { userData, updateUserBalance } = useUserContext()

  const token = utils.getToken()

  useEffect(() => {
    const socketUrl = process.env.REACT_APP_PW_SOCKET_WAGERS
    const websocket = io.connect(socketUrl, {
      query: { token },
      secure: true,
      transports: ['websocket']
    })

    websocket.on('connect', () => {
      const userId = userData?.user ? userData?.user?.id : userData?.id
      websocket.emit('subscribe', userId)
    })

    websocket.on('wager:created', (data) => {
      const wagerAmount = Number(data.amount)
      const balance = utils.getUserBalance()
      balance.balanceReal = balance.balanceReal - wagerAmount
      updateUserBalance(balance)

      if (data.wager) {
        const wager = data.wager
        onWagerCreated(wager)
        API.trackWagerFB(data.amount)
      }
    })

    websocket.on('wager:balance', (data) => {
      const newBalance = Number(data.balance)
      const balance = utils.getUserBalance()
      balance.balanceReal = newBalance
      updateUserBalance(balance)
    })

    websocket.on('wager:error', (data) => {
      if (data && data.code) {
        switch (data.code) {
          // Error
          case 0:
            setShowMessageError(true)
            break
          // Saldo
          case 1:
            setShowMessageSaldo(true)
            break
          default:
            break
        }
      }

      console.log('Wager Error:', data)
      Sentry.captureException(data, {
        extra: 'Error in Casino Wager:error'
      })
    })

    return () => {
      websocket.disconnect()
    }
  }, [token])
}